import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取宠物种类信息 **/
    GET_PET_BREEDS_ALL(data) {
        controller='Pets';
        action='GetBreeds';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取宠物信息列表 **/
    GET_PET_INFO_LIST(data) {
        controller='Pets';
        action='GetPetInfoList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增宠物品种信息 **/
    ADD_PET_BREED(data) {
        controller='Pets';
        action='AddPetBreed';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增宠物信息 **/
    ADD_PET(data) {
        controller='Pets';
        action='AddPet';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑宠物信息 **/
    EDIT_PET(data) {
        controller='Pets';
        action='EditPet';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },
    
    /** 删除宠物操作 **/
    DEL_PET_INFOS(data) {
        controller='Pets';
        action='DelPets';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 批量更新商品品种操作 **/
    UPDATE_PET_BREED_MORE(data) {
        controller='Pets';
        action='UpdatePetBreedMore';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 批量更新宠物性别操作 **/
    UPDATE_PET_SEX_MORE(data) {
        controller='Pets';
        action='UpdatePetSexMore';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取宠物类型信息 **/
    GET_PET_Types(data) {
        controller='Pets';
        action='GetPetTypes';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取是否绝育数据 **/
    GET_TERILIZATION(data) {
        controller='Pets';
        action='GetIssterilization';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取是否中公/母数据 **/
    Get_IS_ZHONG(data) {
        controller='Pets';
        action='Getiszhong';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取毛发类型数据 **/
    Get_HAIR_TYPE(data) {
        controller='Pets';
        action='GetHairType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取血型数据 **/
    Get_BLOOD_TYPE(data) {
        controller='Pets';
        action='GetBloodType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取销售状态数据 **/
    Get_SALE_STATUS(data) {
        controller='Pets';
        action='GetSaleStatus';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取宠物性别列表 **/
    GET_PET_SEX_INFOS(data) {
        controller='Pets';
        action='GetSexList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取宠物分类信息列表 **/
    GET_PET_ATTRIBUTE(data) {
        controller='Pets';
        action='GetAttribute';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取宠物详情 **/
    GET_PET_DETAIL_INFO(data) {
        controller='Pets';
        action='GetPetDetailInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取宠物记录列表 **/
    GET_PET_RECORD_LIST(data) {
        controller='Pets';
        action='GetPetRecordList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取宠物日程提醒列表 **/
    GET_PET_SCHEDULE_LIST(data) {
        controller='Pets';
        action='GetPetScheduleList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取宠物繁育列表 **/
    GET_PET_BIRTH_LIST(data) {
        controller='Pets';
        action='GetPetBirthList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

}